/**
 * @generated SignedSource<<5a099795726b4fbf97c1f598fd011899>>
 * @relayHash 70514cf683bcc08b9ab38b0801acfcfe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c52564fc6e18bfe5d6ffffb644763a69a83c8570f17b6b541dcc96aca53a133e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_AddDesignButtonQuery } from './ui_AddDesignButtonQuery.graphql';

const node: PreloadableConcreteRequest<ui_AddDesignButtonQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c52564fc6e18bfe5d6ffffb644763a69a83c8570f17b6b541dcc96aca53a133e",
    "metadata": {},
    "name": "ui_AddDesignButtonQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
